import React, {Component} from 'react';

export default class ScrollToTopOnMount extends Component {
    componentWillMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return '';
    }
}